import React, {useContext} from 'react'

import {Form, Button} from 'react-bootstrap'
import StoryContext from '../store/context'
import {observer} from 'mobx-react-lite'

const Auth = observer(() => {
  const store = useContext(StoryContext)
  return (
    <div
      style={{
        display: 'flex',
        width: '100%',
        height: '100%',
        alignItems: 'center',
        justifyContent: 'center',
      }}>
      <Form style={{display: 'flex', width: 600}}>
        <div>
          <Form.Group className="mb-3" controlId="formBasicEmail">
            <Form.Label>Користувач</Form.Label>
            <Form.Control
              placeholder="Введите користувача"
              value={store.login}
              onChange={Event => store.setLogin(Event.target.value)}
            />
          </Form.Group>
          <Form.Group className="mb-3" controlId="formBasicPassword">
            <Form.Label>Пароль</Form.Label>
            <Form.Control
              type="password"
              placeholder="Пароль"
              value={store.password}
              onChange={Event => store.setPassword(Event.target.value)}
            />
          </Form.Group>
          <Button variant="primary" onClick={() => store.auth()}>
            ОК
          </Button>{' '}
          <Button variant="primary">Відміна</Button>
        </div>
      </Form>
    </div>
  )
})

export default Auth
